export const rolesApis = {
    roles: 'v1/api/roles',
    editRoles: 'v1/api/roles',
    createRoles: 'v1/api/roles',
    deleteRoles: 'v1/api/roles',
    getRoleById: 'v1/api/roles/:rolesId',
    getRolesUser: 'v1/api/roles/users',
};
